<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" class="gutter-row">
            <a-breadcrumb :style="{ marginBottom: '20px' }">
              <a-breadcrumb-item>
                <router-link tag="a" :to="{ name: 'sites.overview', params: { siteId: this.$route.params.siteId } }">Site</router-link>
              </a-breadcrumb-item>
              <a-breadcrumb-item>
                <router-link tag="a" :to="{ name: 'sites.lists', params: { siteId: this.$route.params.siteId } }">Lists</router-link>
              </a-breadcrumb-item>
              <a-breadcrumb-item>Subscribers</a-breadcrumb-item>
            </a-breadcrumb>
          </a-col>
        </a-row>
        <ListSubscribersTable/>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import ListSubscribersTable from "@/components/ListSubscribersTable.vue";
export default {
  components: {
    Sidebar,
    ListSubscribersTable
  },
  data() {
    return {
      datacollection: null
    };
  },
  methods: {}
};
</script>
<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  margin: 16px;
  font-size: 1.3em;
  text-align: center;
  color: #fff;
}
</style>
